import { create } from 'zustand';
import api from '../utils/axios';
import { get_sessions, revoke_others, revoke_session } from '../utils/apis/auth';

export const useAuthStore = create((set, get) => ({
  token: localStorage.getItem('token'),
  refreshToken: localStorage.getItem('refreshToken'),
  username: localStorage.getItem('username'),
  role: localStorage.getItem('role'),
  autenticado: !!localStorage.getItem('token'),
  message: null,
  loading: false,

  sessions: [],
  loadingSessions: false,

  login: async (datos) =>
  {
    set({ loading: true, message: null });
    try {
      // Use the correct API path configured in the refactored backend
      const response = await api.post('/auth/login', datos);
      const { token, refreshToken, username, role } = response.data;

      if (token) {
        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('username', username);
        localStorage.setItem('role', role || '');
        set({
          token,
          refreshToken,
          username,
          role: role || '',
          autenticado: true,
          loading: false
        });
        return true;
      } else {
        set({ message: response.data.msg || 'Credenciales inválidas', loading: false });
        return false;
      }
    } catch (error) {
      console.error('Error en login:', error);
      set({
        message: error.response?.data?.message || 'Error al conectar con el servidor',
        loading: false
      });
      return false;
    }
  },

  logout: () =>
  {
    localStorage.clear();
    set({
      token: null,
      refreshToken: null,
      username: null,
      role: null,
      autenticado: false,
      message: null,
      sessions: []
    });
    // For HashRouter, we redirect using hash
    window.location.hash = '#/login';
  },

  fetchSessions: async () =>
  {
    set({ loadingSessions: true });
    try {
      const res = await get_sessions();
      set({ sessions: res || [], loadingSessions: false });
    } catch (error) {
      set({ loadingSessions: false });
    }
  },

  closeSession: async (sessionId) =>
  {
    try {
      await revoke_session(sessionId);
      await get().fetchSessions();
    } catch (error) {
      console.error('Error closing session:', error);
    }
  },

  closeOtherSessions: async () =>
  {
    try {
      await revoke_others();
      await get().fetchSessions();
    } catch (error) {
      console.error('Error closing other sessions:', error);
    }
  },

  setAuthMessage: (msg) => set({ message: msg }),

  updateTokens: (token, refreshToken) =>
  {
    localStorage.setItem('token', token);
    if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
    set({ token, refreshToken: refreshToken || localStorage.getItem('refreshToken') });
  }
}));
